<template>
	<section class="ctn">
		<header class="header left">
			<router-link class="paper-action" :to="{ path: `/maintenances`}"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
			<router-link class="paper-action" :to="{ path: `/maintenances/${maintenance.id}/edit`}"><span>{{ $t('edit') }}</span><heim-icon icon="chevron-right"></heim-icon></router-link>
		</header>
		<main class="maintenance-details">
			<section class="info">
				<heim-card>
					<main>
						<div class="row">
							<h1>{{ $t('maintenance') }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('customer') }}</span>
								<span class="badge">{{ maintenance.name }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('title') }}</span>
								<span class="badge" v-if="maintenance.title">{{ maintenance.title }}</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('startDate') }}</span>
                <span class="badge">{{ maintenance.date_start ? $d(new Date(maintenance.date_start), 'short') : "n/a" }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('endDate') }}</span>
                <span class="badge">{{ maintenance.date_end ? $d(new Date(maintenance.date_end), 'short') : "n/a"}}</span>
              </div>
            </div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('techno') }}</span>
								<span class="badge" v-if="maintenance.SiteTypes">
									<router-link :to="{ path: `/types/${ maintenance.SiteTypes.id}/details` }">{{ maintenance.SiteTypes.type }}</router-link>
								</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('manager') }}</span>
								<span class="badge" v-if="maintenance.Users">
									<router-link :to="{ path: `/users/${ maintenance.Users.id}/details` }">{{ maintenance.Users.name }}</router-link></span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>					
            <div class="row">
							<div class="details-row">
								<span>{{ $t('projectMantis') }}</span>
								<span class="badge" v-if="maintenance.mantis_id">
									<a :href="'https://mantis.activbrowser.com/set_maintenance.php?maintenance_id=' + maintenance.mantis_id" target="_blank">
										Mantis {{ maintenance.mantis_id }} <heim-icon icon="open-in-new"></heim-icon>
									</a>
								</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
						<header><h2>{{ $t('description') }}</h2></header>
						<div class="row">
							<p>{{ maintenance.description ? maintenance.description : $t('na') }}</p>
						</div>
					</main>
				</heim-card>
			</section>
			<section class="info">
				<heim-card>
					<main>
						<div class="row">
							<h1>{{ $t('maintenanceCost') }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
            <div class="row">
							<div class="details-row">
								<span>{{ $t('amountTotal') }}</span>
								<span class="badge">{{ maintenance.amount ? $n(maintenance.amount, "currency") : $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('numberDay') }}</span>
								<span class="badge">{{ maintenance.days && maintenance.days !== 0 ? maintenance.days : $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('adr') }}</span>
								<span class="badge">{{ (maintenance.amount && maintenance.days !== 0 && maintenance.days) ? $n((maintenance.amount / maintenance.days), "currency") + ' ' +  $t('byDay') : $t('na') }} </span>
							</div>
						</div>
					</main>
				</heim-card>
        <heim-card>
					<main>
						<div class="row">
							<h1>{{ $t('siteAndApplication') }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
        <heim-card class="site">
					<main>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('nameWebsite') }}</span>
								<span class="badge">{{ maintenance.name_website ? maintenance.name_website : $t('na') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="details-row">
								<span>{{ $t('prodWebsite') }}</span>
								<span class="badge" v-if="maintenance.prod_website">
									<a :href="maintenance.prod_website" target="_blank">
										{{ maintenance.prod_website }}
									</a>
								</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
            <div class="row">
							<div class="details-row">
								<span>{{ $t('stagingWebsite') }}</span>
								<span class="badge" v-if="maintenance.staging_website">
									<a :href="maintenance.staging_website" target="_blank">
										{{ maintenance.staging_website }}
									</a>
								</span>
								<span class="badge" v-else>{{ $t('na') }}</span>
							</div>
						</div>
					</main>
				</heim-card>
				<heim-card class="endpoints">
          <header>
            <h1>{{ $t('invoiceNumber') }}</h1>
          </header>
          <main>
            <div class="row" v-for="(maintenance, idx) in maintenance.Invoices" :key="`endpoint-${idx}`">
              <div class="details-row">
                <span>{{ maintenance.number }}</span>
                <span class="badge">{{ $n(maintenance.amount, "currency") }}</span>
              </div>
            </div>
          </main>
        </heim-card>
			</section>
		</main>
	</section>
</template>


<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimCard from "@/components/layout/card/heim-card.vue";
import { mapState } from "vuex";
import { dateFilter } from "vue-date-fns";

export default {
  name: "MaintenancesDetails",
  components: {
    HeimIcon,
    HeimCard
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: "ll HH:mm"
              },
              scaleLabel: {
                display: true,
                labelString: "Time"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "value"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getMaintenance", id);

    this.$watch(
      vm => vm.maintenance,
      val => {
        this.$store.dispatch("setTitle", `Maintenance - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({
      maintenance: state => state.maintenancesState.maintenance
    })
  },
  methods : {
    getTotal(items) {
      const cost = [];
      items.map(item => {
        cost.push(item.amount);
      });

      return cost.reduce((a, b) => a + b, 0);
    }
  },
  filters: {
    date: dateFilter
  }
};
</script>

<style scoped>
.maintenance-details,
.details-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.details-row {
  width: 100%;
}

.details-row .badge {
  background-color: var(--heim-grey-color);
}

.maintenance-details > .paper-card,
.maintenance-details > .info {
  width: 100%;
  margin-right: 0;
}

.maintenance-details .stats,
.maintenance-details .monitoring {
  margin-bottom: 1em;
}

.info {
  display: flex;
  flex-direction: column;
}

.disabled {
  color: #8b969c;
}

.monitoring,
.site {
  margin-bottom: 1em;
}

.link {
  padding: 1em;
  border-bottom: 1px solid #eee;
}

.link:last-child {
  border: none;
}

.info .paper-card {
  border-radius: 3px 3px 0 0;
}

.paper-card.monitoring,
.paper-card.site {
  border-radius: 0;
}
.details-row span:first-child {
  padding: 0.2rem 0;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .maintenance-details {
    flex-wrap: nowrap;
  }
  .maintenance-details > .paper-card,
  .maintenance-details > .info {
    width: 50%;
    margin-right: 1em;
    height: 100%;
  }
}
</style>
